<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <base-btn
        v-on="on"
        v-bind="attrs"
        icon
        type="neutral"
        small
        :style="customStyle"
        class="pa-0 ask__btn no-ripple"
        :class="customClass"
        @click="onClickBtn"
      >
        <v-icon>mdi-information-symbol</v-icon>
      </base-btn>
    </template>
    <v-row no-gutters :style="customTooltipMessageStyle">
      <span>{{
        customTooltipMessage ? customTooltipMessage : $t('message.knowMore')
      }}</span>
    </v-row>
  </v-tooltip>
</template>

<script>
export default {
  name: 'LearnMoreBtn',
  props: {
    onClickBtn: {
      type: Function,
      required: false,
      default: () => {},
    },
    customTooltipMessage: {
      type: String,
    },
    customTooltipMessageStyle: {
      type: String,
      default: '',
    },
    customStyle: {
      type: String,
      default: 'margin-top: -4px; margin-left: 2px',
    },
    customClass: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
$size: 10px;

.bg-dark {
  .ask {
    &__btn {
      --intro-background-color: rgba(255, 255, 255, 0.54);
      --intro-foreground-color: #000;
    }
  }
}

.ask {
  &__btn {
    --intro-background-color: var(--v-neutral-lighten1);
    --intro-foreground-color: var(--v-neutral-lighten4);

    position: relative;
    top: 0.5px;

    &::v-deep {
      .v-icon {
        background-color: varFigma(neutral-70);
        width: $size;
        height: $size;
        border-radius: 100%;

        &[class*='mdi-'] {
          font-size: $size * 0.8;

          &::before {
            color: var(--intro-foreground-color);
          }
        }
      }
    }
    &--tiny {
      &::v-deep {
        height: 26px;
        .v-icon {
          width: 1rem;
          height: 1rem;

          &[class*='mdi-'] {
            font-size: 1rem * 0.8;
          }
        }
      }
    }
    &--medium {
      &::v-deep {
        height: 26px;
        .v-icon {
          width: 1.5rem;
          height: 1.5rem;

          &[class*='mdi-'] {
            font-size: 1.5rem * 0.8;
          }
        }
      }
    }
  }
}
</style>
